// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Drxcl","title":"Info_title__2EvFd","selects":"Info_selects__jU6iI","requiredAsterisk":"Info_requiredAsterisk__1N76p"};